export default __webpack_public_path__ + "static/media/contact-us-image-mobile.fedf284f.png";